export enum FilterTypeEnum {
    DATE = 'DATE',
    SELECTOR = 'SELECTOR',
    TREE = 'TREE',
    YEAR = 'YEAR',
}

export enum DateFilterTypeEnum {
    IDENTITY = 'IDENTITY',
    RANGE = 'RANGE',
    EXTRACT = 'EXTRACT',
    DYNAMIC = 'DYNAMIC',
    REGULAR = 'REGULAR',
}
